// extracted by mini-css-extract-plugin
export default {"genericCard":"tq-z","inline":"uq-z","mastercard":"vq-z","discover":"wq-z","visa":"xq-z","amex":"yq-z","active":"zq-z"};